import type { Highlight } from './paint';
import type { Stage } from './stages';

export type Item =
  | {
      kind: 'gate';
      el: HTMLElement;
      from: Stage;
      to: Stage;
      highlight?: Highlight;
    }
  | {
      kind: 'section';
      el: HTMLElement;
      stage: Stage;
      prev: Stage;
      gated: boolean;
      highlight?: Highlight;
    };

const parseHighlight = (raw: string | undefined): Highlight | undefined => {
  if (!raw) return undefined;
  const [from, to] = raw.split('|');
  return { from, to };
};

export const collectItems = (root: HTMLElement): Item[] => {
  const items: Item[] = [];
  let lastStage: Stage | null = null;

  for (const el of root.querySelectorAll<HTMLElement>('[data-scrolly]')) {
    if (el.dataset.scrolly === 'section') {
      const stage = el.dataset.stage as Stage;
      items.push({
        kind: 'section',
        el,
        stage,
        prev: lastStage ?? stage,
        gated: items.at(-1)?.kind === 'gate',
        highlight: parseHighlight(el.dataset.highlight),
      });
      lastStage = stage;
    } else {
      items.push({
        kind: 'gate',
        el,
        from: lastStage ?? 'published',
        to: lastStage ?? 'published',
      });
    }
  }

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.kind !== 'gate') continue;
    const target = items.slice(i + 1).find((next) => next.kind === 'section');
    if (target?.kind === 'section') {
      item.to = target.stage;
      item.highlight = target.highlight;
    }
  }

  return items;
};
